import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.isAndroid =
      window?.Android && typeof window.Android.onBack == "function";
    this.isIOS = window.webkit && window.webkit.messageHandlers;
    this.isBrowser = !this.isAndroid && !this.isIOS;
  }

  perform(e) {
    e.preventDefault();

    if (e.params.name) {
      this.sendCommand(e.params.name, e.params);
    }
  }

  sendCommand(name, params) {
    delete params["name"];

    if (this.isAndroid) {
      this.sendAndroidCommand(name, params);
    }

    if (this.isIOS) {
      this.sendIOSCommand(name, params);
    }

    if (this.isBrowser) {
      this.sendBrowserCommand(name, params);
      console.log(name);
      console.log(params);
    }
  }
  sendBrowserCommand(name, params) {
    switch (name) {
      case "navigateTo":
        window.location.href = params.url;
        break;
      case "navigateToBack":
        history.back();
        break;
      case "requireAuth":
        // Android.requireAuth();
        break;
      case "openInWebview":
        window.location.href = params.url + "&navbar=true";
        break;
    }
  }
  sendAndroidCommand(name, params) {
    switch (name) {
      case "logout":
        Android.logout();
        break;
      case "navigateTo":
        Android.navigateTo(params.url);
        break;
      case "navigateToBack":
        Android.onBack();
        break;
      case "requireAuth":
        Android.requireAuth();
        break;
      case "openInWebview":
        Android.openWebViewBottomSheet(params.url);
        break;
    }
  }

  sendIOSCommand(name, params) {
    webkit.messageHandlers.performAction.postMessage({
      action: name === "openInWebview" ? "navigateTo" : name,
      data: params,
    });

    // if (name == "showSlotGame" || name == "showMemoryGame") {
    //   webkit.messageHandlers.performAction.postMessage({
    //     action: 'navigateTo',
    //     data: params
    //   });
    // }
  }
}
